import "./interface.scss";

import PropTypes from "prop-types";
import React, { Component } from "react";
import { Popover, PopoverBody } from "reactstrap";

import hasAncestorOfClass from "../../utils/hasAncestorOfClass";

let tooltipTimer;
const clickWasTooltip = e => hasAncestorOfClass(e.target, "popoverTooltipLabel");

class PopoverTooltip extends Component {
  constructor(props) {
    super(props);

    this.state = { tooltipOpen: false };

    this.onWindowClick = this.onWindowClick.bind(this);

    this._closeOnClick = false;
  }

  componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ tooltipOpen: this.props.tooltipOpen });
    window.addEventListener("mousedown", this.onWindowClick);
    tooltipTimer = setTimeout(() => {
      this._closeOnClick = true;
    }, 3000);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.tooltipOpen !== nextProps.tooltipOpen) {
      this.setState({ tooltipOpen: nextProps.tooltipOpen });
    }
  }

  componentDidUpdate() {
    clearTimeout(tooltipTimer);
    tooltipTimer = setTimeout(() => {
      this._closeOnClick = true;
    }, 3000);
  }

  componentWillUnmount() {
    window.removeEventListener("mousedown", this.onWindowClick);
    clearTimeout(tooltipTimer);
  }

  onWindowClick = e => {
    const clickedNotification = clickWasTooltip(e);
    if (this._closeOnClick && !clickedNotification) {
      this.setState({ tooltipOpen: false });
    } else if (clickedNotification) {
      this.setState({ tooltipOpen: false });
    }
  };

  render() {
    const popoverPlacement = this.props.popoverPlacement ? this.props.popoverPlacement : "bottom";

    return (
      <Popover
        placement={popoverPlacement}
        className="popoverTooltip"
        target={this.props.target}
        trigger="click"
        isOpen={this.state.tooltipOpen}
      >
        <PopoverBody>
          <div className={`popoverTooltipLabel ${popoverPlacement ? popoverPlacement : ""}`}>{this.props.label}</div>
        </PopoverBody>
      </Popover>
    );
  }
}

PopoverTooltip.propTypes = {
  tooltipOpen: PropTypes.bool,
  popoverPlacement: PropTypes.string,
  label: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired
};

export default PopoverTooltip;
